import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Layers } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const OfferGroupsSettings = () => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/offer-groups").then((r) => setRows(r.data)); }, []);
  const upd = (i, patch) => setRows(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/offer-groups", rows);
      setRows(data);
      toast.success("Grup penawaran tersimpan");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-premium p-6 mb-6 max-w-4xl fade-up" data-testid="offer-groups-card">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div>
          <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500"><Layers className="h-4 w-4" />Grup Penawaran</p>
          <p className="text-xs text-slate-500">Daftar grup yang bisa dipilih sales di kolom Grup item. Pengaturan bawaan otomatis terpasang saat grup dipilih.</p>
        </div>
        <Button size="sm" variant="outline" className="bg-white" onClick={() => setRows([...rows, { name: "", unit: "Lot", cost_only: false, show: true }])} data-testid="offer-group-add-btn"><Plus className="h-4 w-4 mr-1" />Tambah Grup</Button>
      </div>
      <div className="space-y-2">
        {rows.map((g, i) => (
          <div key={i} className="flex flex-wrap items-center gap-3 rounded-lg border border-slate-200 bg-white p-2.5 text-xs" data-testid={`offer-group-row-${i}`}>
            <Input className="h-9 min-w-[200px] flex-1 bg-white text-sm" placeholder="Nama grup" value={g.name} onChange={(e) => upd(i, { name: e.target.value })} data-testid={`offer-group-name-${i}`} />
            <select className="h-9 rounded-md border border-input bg-white px-2" value={g.unit} onChange={(e) => upd(i, { unit: e.target.value })} data-testid={`offer-group-unit-${i}`}>
              <option value="Lot">Lot</option><option value="Set">Set</option>
            </select>
            <label className="flex items-center gap-1.5 text-violet-700"><input type="checkbox" className="accent-violet-700" checked={!!g.cost_only} onChange={(e) => upd(i, e.target.checked ? { cost_only: true, show: false } : { cost_only: false })} data-testid={`offer-group-costonly-${i}`} />Komponen cost saja</label>
            <label className="flex items-center gap-1.5 text-slate-600"><input type="checkbox" className="accent-blue-700" checked={!!g.show && !g.cost_only} disabled={!!g.cost_only} onChange={(e) => upd(i, { show: e.target.checked })} data-testid={`offer-group-show-${i}`} />Tampilkan rincian</label>
            <Button size="icon" variant="ghost" onClick={() => setRows(rows.filter((_, idx) => idx !== i))} data-testid={`offer-group-delete-${i}`}><Trash2 className="h-4 w-4 text-rose-500" /></Button>
          </div>
        ))}
        {!rows.length && <p className="text-sm text-slate-400">Belum ada grup.</p>}
      </div>
      <Button className="mt-4" onClick={save} disabled={busy || !rows.length || rows.some((r) => !r.name.trim())} data-testid="offer-groups-save-btn">Simpan Grup</Button>
    </div>
  );
};
